let configCache;

export function extractConfigFromDom() {
	const configSelector = '.o-keywordsearch__config';

	if (configCache) {
		return configCache;
	}

	let result = document.querySelector(configSelector).textContent;
	if (result) {
		try {
			// remove new lines
			result = result.replace(/\n/g, '');
			configCache = JSON.parse(result);
		} catch (error) {
			console.log('extractFromDom => Unreadable result', error, result);
		}
	}
	return configCache;
}
